export default __webpack_public_path__ + "static/media/video.bb27107b.mp4";